import React from "react";
import { twMerge } from "@stereoagency/tailwind-config";
import { Container } from "../../atoms";
import { MediaBlock } from "../../molecules";
export default function MediaSection(param) {
    var _param_variant = param.variant, variant = _param_variant === void 0 ? "default" : _param_variant, image = param.image, video = param.video, label = param.label, className = param.className;
    if (variant === "fill") {
        return /*#__PURE__*/ React.createElement("div", {
            "data-section-name": MediaSection.name,
            className: className
        }, /*#__PURE__*/ React.createElement(MediaBlock, {
            image: image,
            video: video,
            label: label
        }));
    }
    return /*#__PURE__*/ React.createElement(Container, {
        name: MediaSection.name,
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: twMerge(variant === "default" && "mx-auto max-w-md", variant === "small" && "mx-auto max-w-sm")
    }, /*#__PURE__*/ React.createElement(MediaBlock, {
        image: image,
        video: video,
        label: label
    })));
}

//# sourceMappingURL=MediaSection.js.map